var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.5H19.5V9H18V18.75C18 18.9489 17.921 19.1397 17.7803 19.2803C17.6397 19.421 17.4489 19.5 17.25 19.5H6.75C6.55109 19.5 6.36032 19.421 6.21967 19.2803C6.07902 19.1397 6 18.9489 6 18.75V9H4.5V7.5H8.25V5.25C8.25 5.05109 8.32902 4.86032 8.46967 4.71967C8.61032 4.57902 8.80109 4.5 9 4.5H15C15.1989 4.5 15.3897 4.57902 15.5303 4.71967C15.671 4.86032 15.75 5.05109 15.75 5.25V7.5ZM16.5 9H7.5V18H16.5V9ZM13.0605 13.5L14.3865 14.826L13.326 15.8865L12 14.5605L10.674 15.8865L9.6135 14.826L10.9395 13.5L9.6135 12.174L10.674 11.1135L12 12.4395L13.326 11.1135L14.3865 12.174L13.0605 13.5ZM9.75 6V7.5H14.25V6H9.75Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagDelete);
export default __webpack_public_path__ + "static/media/tagDelete.a23e8f4b.svg";
export { ForwardRef as ReactComponent };